import React, { Component } from 'react'
import NumberFormat from "react-number-format";
import { connect } from 'react-redux'
import $ from 'jquery';
import { createPaymentPages } from '../../../state/ducks/payment/types';
import AppCustomSelect from '../shared/AppCustomSelect';
import { setCustomSelectFieldState } from '../../../utils/customSelect';

function ValidateCreditCardNumber() {
    var ccNum = document.getElementById("cardNo").value.replace(/\D/g, '');
    var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
    var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
    var amexpRegEx = /^(?:3[47][0-9]{13})$/;
    var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
    var troyRegEx = /^(?:9[0-9]{12}(?:[0-9]{3})?)$/;
    var isValid = false;

    if (visaRegEx.test(ccNum)) {
        isValid = true;
    } else if (mastercardRegEx.test(ccNum)) {
        isValid = true;
    } else if (amexpRegEx.test(ccNum)) {
        isValid = true;
    } else if (discovRegEx.test(ccNum)) {
        isValid = true;
    } else if (troyRegEx.test(ccNum)) {
        isValid = true;
    }

    if (isValid) {
        return true;
    } else {
        return false;
    }
}
function formKontrol(creditcard) {
    var cardAdi = $("#cardAdi").val();
    var cardNo = $("#cardNo").val();
    var cardTarih = creditcard?.expirationMonth;
    var cardTarihYıl = creditcard?.expirationYear;
    var cardCvv = $("#cardCvv").val();
    var durum = 1;
    // kuruş alanı boş ise kuruş 00 olduğu kabul edilir. O sebep ile kontrol dışı.
    //var patternCredit = /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/;
    //var sdurum = patternCredit.test(cardNo.replace(/\D/g, ''));
    // Card Adı boş mu dolu mu ?

    if (cardAdi == "") {
        durum = 0; // Konu Boş
        $("#cardAdi").parent().addClass("t-error");
        $("#cardAdi").next().html("<i class='t-icon-error text-danger'></i>");
        $("#cardAdi_hatamesaj").html("Kart Adı alanı boş bırakılamaz.");
    } else {
        $("#cardAdi").parent().removeClass("t-error");
        $("#cardAdi").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#cardAdi_hatamesaj").html("");
    }
    // Card No boş mu dolu mu ?
    if (cardNo == "") {
        durum = 0; // Konu Boş
        $("#cardNo").parent().addClass("t-error");
        $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
        $("#cardNo_hatamesaj").html("Kart Numarası alanı boş bırakılamaz.");
    } else {
        if (ValidateCreditCardNumber() == false) {
            durum = 0;
            $("#cardNo").parent().addClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-error text-danger'></i>");
            $("#cardNo_hatamesaj").html("Kart Numarasını kontrol ediniz.");
        }
        else {

            $("#cardNo").parent().removeClass("t-error");
            $("#cardNo").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
            $("#cardNo_hatamesaj").html("");
        }
    }
    // Card Tarih boş mu dolu mu ?
    if (cardTarih == "" || cardTarihYıl == "") {
        durum = 0;

        setCustomSelectFieldState("cardTarihYıl", true);
        $("#cardTarih_hatamesaj").html("Tarih alanı boş bırakılamaz.");
    } else {
        setCustomSelectFieldState("cardTarihYıl", false);
        $("#cardTarih_hatamesaj").html("");
    }
    // Card CVV boş mu dolu mu ?
    if (cardCvv == "") {
        durum = 0; // Konu Boş
        $("#cardCvv").parent().addClass("t-error");
        $("#cardCvv").next().html("<i class='t-icon-error text-danger'></i>");
        $("#cardCvv_hatamesaj").html("CVV alanı boş bırakılamaz.");
    } else {
        $("#cardCvv").parent().removeClass("t-error");
        $("#cardCvv").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
        $("#cardCvv_hatamesaj").html("");
    }

    return durum;

}
export class CreditCard extends Component {
    state = {
        cardHolderName: "",
        cardNumber: "",
        expirationMonth: "",
        expirationYear: "",
        cvv: ""
    };
    onSubmit = e => {
        e.preventDefault();
        const { creditcard } = this.props;

        if (formKontrol(creditcard) == 0) {
            return false;
        }
        this.props.changePage(createPaymentPages.sms, true);
    }

    render() {
        const { creditcard } = this.props;
        var dt = new Date();
        const yearArray = Array.from({ length: 13 }, (_, i) => dt.getFullYear() + i);
        return (
            <>
                <div className="row" style={{ padding: "3%" }}>
                    <div className="col-12">
                        {/* KUTU 1 */}
                        <div className="row no-gutters t-kutu t-yesilCizgi">
                            <div
                                className="col bosluk backtop"
                                style={{
                                    backgroundImage: 'url("/assets/img/backgrounds/back_top_yesil.jpg")'
                                }}
                            >
                                {/* içerikler */}
                                {/* Başlık */}
                                <div className="row no-gutters pb-4">
                                    <div clss="col-auto">
                                        <i className="t-icon-credit-card  icon" />
                                    </div>
                                    <div className="col d-flex flex-column justify-content-center">
                                        <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                                            Ödeme Talimatı
                                        </div>
                                        <span className="altBaslik">Ödeme Talimatı Verme</span>
                                    </div>
                                </div>
                                {/* KART */}
                                <div className="row no-gutters pb-4">
                                    <div className="col-12 d-flex justify-content-center">
                                        <img
                                            src="/assets/img/svg/kredikard.svg"
                                            style={{ width: "50%", height: "auto" }}
                                        />
                                    </div>
                                    <div className="col-12 pb-2 t-icBaslikTuruncu">
                                        KART BİLGİLERİNİ GİRİNİZ
                                    </div>
                                    <div className="col-12 pb-3 t-icHatirlatmaYazisi">
                                        Kart bilgileriniz sadece sizin bankanızda saklanır. Emin Üstün
                                        Holding dahil bankanız haricinde kimse tarafından görülemez.
                                    </div>
                                </div>
                                <div className="row no-gutters">
                                    <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">Kart Sahibi</span>
                                    </div>
                                    {/* Kartın Üzerindeki İsim*/}
                                    <div className="col-12">
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-user1" />
                                            </div>

                                            <input type="text"
                                                id="cardAdi"

                                                maxLength="50"
                                                pattern="^\s*[a-zA-Z,ç,Ç,ğ,Ğ,ı,İ,ö,Ö,ş,Ş,ü,Ü,\s]+\s*$"
                                                title="Sadece türkçe karakter girmelisiniz."
                                                placeholder="Kartın Üzerindeki İsimi Yazınız"
                                                value={creditcard.cardHolderName}
                                                onChange={e => {
                                                    creditcard.cardHolderName = e.target.value;
                                                    this.setState({ cardHolderName: e.target.value });

                                                }} />
                                            <div />
                                        </div>
                                    </div>
                                    {/* Hata mesajının geleceği alan*/}
                                    <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="cardAdi_hatamesaj"
                                    />
                                    <div className="col-12 pb-1">
                                        <span className="t-icInputTitle pl-3">Kart Numarası</span>
                                    </div>
                                    {/* Kart Numarası*/}
                                    <div className="col-12">
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-info1 " />
                                            </div>

                                            <NumberFormat
                                                displayType={"input"}
                                                format="####-####-####-####"
                                                id="cardNo"
                                                className="cardNo"
                                                title="Hatalı kart numarası"
                                                value={creditcard.cardNumber}
                                                onChange={e => {
                                                    creditcard.cardNumber = e.target.value.trim();
                                                    this.setState({ cardNumber: e.target.value.trim() });
                                                }} />
                                            <div />
                                        </div>
                                    </div>
                                    {/* Hata mesajının geleceği alan*/}
                                    <div
                                        className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                                        id="cardNo_hatamesaj"
                                    />
                                    {/* Kart Son kullanım Tarihi*/}
                                    <div className="col-12 col-md-6">
                                        <span className="t-icInputTitle pl-3 pb-2">
                                            Son Kullanım Tarihi
                                        </span>
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-calendar1" />
                                                &nbsp;&nbsp;
                                            </div>

                                            <AppCustomSelect
                                                id="cardTarih"
                                                className="t-eminPayCustomSelect--expiryMonth"
                                                value={creditcard.expirationMonth}
                                                options={Array.from({ length: 12 }, (_, i) => i + 1).map((item) => ({
                                                    value: String(item),
                                                    label: String(item),
                                                }))}
                                                onChange={(nextValue) => {
                                                    creditcard.expirationMonth = nextValue;
                                                    this.setState({ expirationMonth: nextValue });
                                                }}
                                            />
                                            <div />
                                            &nbsp;&nbsp;
                                            <AppCustomSelect
                                                id="cardTarihYıl"
                                                className="t-eminPayCustomSelect--expiryYear"
                                                value={creditcard.expirationYear}
                                                options={yearArray.map((item) => ({
                                                    value: String(item),
                                                    label: String(item),
                                                }))}
                                                onChange={(nextValue) => {
                                                    creditcard.expirationYear = nextValue;
                                                    this.setState({ expirationYear: nextValue });
                                                }}
                                            />
                                            <div>

                                            </div>
                                        </div>
                                        {/* Hata yeri*/}
                                        <div
                                            className="t-icinputHatamesajArea pt-1 pl-3"
                                            id="cardTarih_hatamesaj"
                                        />
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <span className="t-icInputTitle pl-3 pb-2">CVV2 Kodu</span>
                                        <div className="t-icInput">
                                            <div>
                                                <i className="t-icon-credit-card" />
                                            </div>

                                            <NumberFormat
                                                displayType={"input"}
                                                format="###"
                                                pattern="^[0-9]*$"

                                                type="text"
                                                id="cardCvv"
                                                className="cardCvv"
                                                maxLength="50"
                                                // maxlength="3" 
                                                required
                                                value={creditcard.cvv}
                                                onChange={e => {
                                                    creditcard.cvv = e.target.value
                                                    this.setState({ cvv: e.target.value });

                                                }} />
                                            <div />
                                        </div>
                                        {/* Hata Yeri*/}
                                        <div
                                            className="t-icinputHatamesajArea pt-1 pl-3"
                                            id="cardCvv_hatamesaj"
                                        />
                                    </div>
                                    {/* Button */}
                                    <div className="col-12 d-flex justify-content-center pb-3">
                                        <button className="t-icButonTrunucu" onClick={() => this.props.changePage(createPaymentPages.orderDetail)}>
                                            <i className="t-icon-arrow-left2" />
                                            <span>Geri</span>
                                        </button>

                                        <button className="t-icButtonYesil" onClick={this.onSubmit}>
                                            <span>Devam</span>
                                            <i className="t-icon-arrow-right2" />
                                        </button>
                                    </div>

                                </div>
                                {/* STEP LER */}
                                <div className="row no-gutters pt-4 justify-content-center align-items-start">
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                    {/* 1*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">1</div>
                                        </div>
                                        <span>Ödeme Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepAktif">
                                        <div className="ortala">
                                            <div className="yuvarlak">2</div>
                                        </div>
                                        <span>Kart Bilgileri</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-auto t-cizgiBackgroundOrta" />
                                    {/* 2*/}
                                    <div className="col-auto t-icStepPasif">
                                        <div className="ortala">
                                            <div className="yuvarlak">3</div>
                                        </div>
                                        <span>Onay</span>
                                    </div>
                                    {/* cizgi*/}
                                    <div className="col-1 t-cizgiBackgroundKenar" />
                                </div>
                                {/* içerikler BİTTİ */}
                                <div className="row no-gutters pt-0 pb-4 justify-content-center align-items-start">
                                    .
                                </div>
                            </div>
                            <div className="col-auto renk" />
                        </div>
                        {/* KUTU 1 BİTTİ */}
                    </div>

                </div>
                {/* Duyurlar Baslık*/}
                {/* duyrular Bitti*/}
                <div className="row" style={{ height: 30 }} />
            </>

        )
    }
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(CreditCard)
